module.exports = __webpack_public_path__ + "img/imagem1.450a168e.jpg";